export const getUsernameById = (userId, users) => {
    const user = users.find(u => u.id === userId);
    return user?.username || 'Unknown User';
};

